import { css } from '@emotion/react';

const errorGlobalStyle = css`
  body {
    display: flex !important;
  }
`;

export default errorGlobalStyle;
